import { useSelector } from 'react-redux';
import { selectProfileInfo } from 'store/profile';
import { Scorecard } from 'store/interfaces';

export default function useIsPeopleManagerForScorecard(
  scorecard?: Scorecard | null,
) {
  const currentUser = useSelector(selectProfileInfo);

  if (!scorecard?.careerMentor || !currentUser?.id) {
    return false;
  }

  return currentUser.id === scorecard.careerMentor.id;
}
